<template>
    <div>
        <div ref="page" v-html="text"></div>
	</div>
</template>

<script>
	import store from "../store";

	var clone = require("clone");
	
	const Handlebars = require('handlebars');
	const H = require('just-handlebars-helpers');

	// Register just-handlebars-helpers with handlebars
	H.registerHelpers(Handlebars);

	export default {
		name: "page",
        components: {
        },
        data: function () {
            return {	
				text: "",
            }
        },
		watch: {
			currentLocale()
			{
				this.load_data();
			},
			page: {
				deep: true,
                immediate: true,
				handler: function (newVal, oldVal) {
					this.load_data();
				}
			},
			lang() {
				this.load_data();
			}
        },
		props: {
			page: {
				default: () => {}
			},
			lang: {
				default: null
			}
		},
		computed: {
			currentLocale()
			{
				return this.$root.$i18n.locale;
			},
            user_vuex: function() {
                return store.getters.getUser;
            },
		},
        methods: {
			async load_data()
			{
				var text = typeof this.page == "object" ? this.page[this.lang || this.currentLocale] : this.page;

				if (!text)
					return;

				var template = Handlebars.compile(text);

				this.text = template({ identifiant: this.user_vuex.identifiant || "" });

				await this.$nextTick();

				this.executeScripts()
				
			},
			handleLinkClick(event) {
				const href = event.currentTarget.getAttribute('href');

				if (!href.startsWith("http"))
				{
					event.preventDefault();
					// tu peux faire une navigation interne avec Vue Router ici
					this.$router.push(href);
				}
			},
			executeScripts() {
				const container = this.$refs.page;
				if (!container) return;

				container.querySelectorAll('a').forEach(link => {
					link.addEventListener('click', this.handleLinkClick);
				});

				const scripts = container.querySelectorAll('script');

				scripts.forEach((oldScript) => {
					const newScript = document.createElement('script');

					// Copie des attributs (type, src, etc.)
					Array.from(oldScript.attributes).forEach(attr => {
					newScript.setAttribute(attr.name, attr.value);
					});

					// Copie le contenu JS
					newScript.text = oldScript.text;

					// Ajout au DOM pour exécution
					document.body.appendChild(newScript);
					document.body.removeChild(newScript); // Nettoyage
				});
			},
        },
		mounted: async function () {
			this.load_data()
		},
	};
</script>

<style></style>
